export const playgroundPath = "/playground";

export default playgroundPath;
